import { Button, Card, Empty, Flex, Select, Space, Switch, Table, Tag, Typography } from 'antd';

const { Text } = Typography;

const NotificationSettingsDesktop = ({ viewModel }) => {
  const {
    loading,
    submitting,
    rows,
    roleOptions,
    userOptions,
    loadData,
    updateRow,
    saveAll,
  } = viewModel;

  const columns = [
    {
      title: 'Loại thông báo',
      key: 'event_type',
      width: 260,
      render: (_, row) => (
        <Space direction='vertical' size={2}>
          <Text strong>{row.label}</Text>
          <Text type='secondary'>{row.description}</Text>
          <Tag>{row.event_type}</Tag>
        </Space>
      ),
    },
    {
      title: 'Bật/Tắt',
      key: 'enabled',
      width: 120,
      render: (_, row) => (
        <Switch
          checked={row.enabled}
          onChange={(checked) => updateRow(row.event_type, { enabled: checked })}
        />
      ),
    },
    {
      title: 'Nhận theo vai trò (fallback)',
      key: 'roles',
      width: 320,
      render: (_, row) => (
        <Select
          mode='multiple'
          allowClear
          value={row.roles}
          options={roleOptions}
          style={{ width: '100%' }}
          placeholder='Chọn vai trò nhận thông báo'
          onChange={(value) => updateRow(row.event_type, { roles: value || [] })}
        />
      ),
    },
    {
      title: 'Người nhận cụ thể (ưu tiên)',
      key: 'recipient_ids',
      render: (_, row) => (
        <Select
          mode='multiple'
          allowClear
          value={row.recipient_ids}
          options={userOptions}
          style={{ width: '100%' }}
          placeholder='Nếu chọn, hệ thống sẽ gửi đúng các user này'
          onChange={(value) => updateRow(row.event_type, { recipient_ids: value || [] })}
          optionFilterProp='label'
        />
      ),
    },
  ];

  return (
    <Space direction='vertical' size={16} style={{ width: '100%' }}>
      <Card
        title='Cấu hình nhận thông báo'
        extra={
          <Flex gap={8}>
            <Button onClick={loadData} loading={loading}>Tải lại</Button>
            <Button type='primary' onClick={saveAll} loading={submitting}>Lưu cấu hình</Button>
          </Flex>
        }
      >
        <Space direction='vertical' size={4} style={{ width: '100%', marginBottom: 12 }}>
          <Text type='secondary'>Thiết lập người nhận theo từng loại thông báo. Nếu có Người nhận cụ thể, hệ thống sẽ ưu tiên gửi cho danh sách này.</Text>
          <Text type='secondary'>Nếu để trống Người nhận cụ thể, hệ thống dùng Vai trò fallback để xác định người nhận.</Text>
        </Space>

        <Table
          rowKey='event_type'
          loading={loading}
          dataSource={rows}
          columns={columns}
          pagination={false}
          locale={{
            emptyText: <Empty description='Không có cấu hình thông báo' image={Empty.PRESENTED_IMAGE_SIMPLE} />,
          }}
          scroll={{ x: 1100 }}
        />
      </Card>
    </Space>
  );
};

export default NotificationSettingsDesktop;
